<template>
  <div class="collaborators">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Nossos Colaboradores</div>
          <div
            class="page-description"
          >Conheça os nosso principais colaboradores. Temos hoje {{numArticles}} artigos e pareceres publicados nos Boletins da Governet.</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                  >
                    <template v-slot:cell(foto_url)="data">
                      <img
                        class="avatar"
                        alt="avatar"
                        :src="data.value ? data.value:require(`@/assets/no-image.png`)"
                        data-holder-rendered="true"
                      />
                    </template>
                    <template v-slot:cell(name)="data">
                      <span class="name-author">{{data.value}}</span>
                      <div class="qualification">
                        {{data.item.qualification}}
                      </div>                      
                    </template>
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Sem dados</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "@/main";

export default {
  name: "collaborators",
  data() {
    return {
      numArticles: '',
      perPage: 6,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "foto_url", label: "" },
        { key: "name", label: "" },
      ]
    };
  },
  mounted() {
    this.providerData();
    this.getCountArticles();
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    getCountArticles() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/get_count_texts_index?index_name=Artigos e Pareceres`
        )
        .then(response => {        
          this.numArticles = response.data;
        });
    },
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/authors_public?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        "filter[main_site]=1&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage;

      return url;
    },
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.collaborators{
  .name-author{
    font-weight: bold;
    color: $red_primary;
    font-size: 18px;
  }
  .qualification{
    margin-top: 6px;
    color: #5f6064;
  }
  table{
    thead{
      display: none;
    }
  }
}
</style>